import React from 'react';

import Box from '@amzn/meridian/box';
import { type BoxProps } from '@amzn/meridian/box/box';
import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Grid from 'src/components/shared/grid/grid';
import { htmlAttributeSanitize } from 'src/utils/helpers';

// **** Types **** //

interface SectionTitleProps {
  label: string;
  editButtonDisabled?: boolean;
  editButtonOnClick: () => void;
}

export interface ItemProps {
  label: string;
  value: string | number | null | undefined;
}

// **** Functions **** //

/**
 * Section title and "Edit Info" button.
 */
export const SectionTitle = (props: SectionTitleProps) => {
  const { label, editButtonDisabled, editButtonOnClick } = props;
  return (
    <Row alignmentHorizontal="justify" spacingInset="none none 200 none">
      <Box>
        <Text type="h300">{label}</Text>
      </Box>
      <Box>
        <Button type="link" disabled={!!editButtonDisabled} onClick={editButtonOnClick}>
          Edit Info
        </Button>
      </Box>
    </Row>
  );
};

/**
 * Section Wrapper
 */
export const SectionWrapper = (props: { label: string; items: ItemProps[] }) => {
  const { label, items } = props;
  return (
    <Box type="outline" spacingInset="400">
      {/* Label */}
      <Box spacingInset="none none 400 none">
        <Text type="h200">{label}</Text>
      </Box>

      {/* Grid */}
      <Grid columns={3}>
        {items.map((item, i) => (
          <ItemPropsDisplay key={i} index={i} label={item.label} value={item.value} />
        ))}
      </Grid>
    </Box>
  );
};

/**
 * Element to display a property
 */
export const ItemPropsDisplay = (props: BoxProps & ItemProps & { index: number }) => {
  const { index, label, value, ...otherProps } = props;
  return (
    <Box {...otherProps}>
      <Box>
        <Text color="secondary" type="b200">
          {label}
        </Text>
      </Box>
      <Box>
        <Text type="b300" data-cy={`new-jmr__review__${htmlAttributeSanitize(label)}`}>
          {value || '--'}
        </Text>
      </Box>
    </Box>
  );
};
